import { AppConfig } from 'features/config/config.model';
import React, { createContext, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/root-reducer';
import { reactPlugin, aiInit } from './app-insights';

const AppInsightsContext = createContext(reactPlugin);
const AppInsightsContextComponent = AppInsightsContext.Provider;

const useAppInsightsContext = (): typeof reactPlugin => useContext(AppInsightsContext);

export interface IAppInsightsContextProviderProps {
    children: JSX.Element | JSX.Element[];
}

const AppInsightsContextProvider = ({ children }: IAppInsightsContextProviderProps): JSX.Element => {
    const config = useSelector((state: RootState) => state.globalElements.appConfig as AppConfig);

    useEffect(() => {
        if (config) {
            aiInit(config?.APP_INSIGHTS_KEY);
        }
    }, [config]);

    return <AppInsightsContextComponent value={reactPlugin}>{children}</AppInsightsContextComponent>;
};

export { AppInsightsContext, AppInsightsContextProvider, useAppInsightsContext };
